<template>
  <div class="list-item-search list-item-search-view-mobile" :class="{'bg-yellow': isHighlight}">
    <div class="right-side">
      <div v-if="isQuickSale" class="hot">
          <div>{{$t('packages.quickSale.title')}}</div>
        </div>
      <b-card-img :src="urlImage.replace('832x468', '250x141')" class="img-card"></b-card-img>
      <div v-if="isFeature" class="bookmark">
          <div class="start-while">
            <StarIcon />
          </div>
        </div>
    </div>
    <ul class="ul-list-item">
      <li class="location-div">
        <span class="location">{{ district }} > {{ province }}</span>
      </li>
      <li>
        <span class="title">{{ funcSubString(title, 50) }}</span>
      </li>
      <li class="price-row" v-if="!salaryType">
        <span class="price">
              <span v-if="minSalary">
                {{minSalary}} {{ $t('baht') }} - 
              </span>
              {{ price.toLocaleString("th-TH") }} {{ $t('baht') }}
        </span>
      </li>
      <li class="price-row" v-if="salaryType">
        <span class="price">{{ salaryType }}</span>
      </li>
      <li class="price-row" v-if="isNegotiable">
        <span class="span-negotiable">{{$t('packages.negotiable.title')}}</span>
      </li>
      <li>
        <span @click.prevent="favorite" class="card-favorite">
          <IconFavoriteBorder v-if="!isFavorite" />
          <FavoriteIcon v-else />
        </span>
        <span class="card-setting" @click.prevent="funcSetting">
          <IconSetting/>
        </span>
      </li>
    </ul>
    <div class="clearfix"></div>
    <b-toast id="favourite-toast" variant="warning" solid ref="favourite-toast">
        <template v-slot:toast-title>
          <div class="d-flex flex-grow-1 align-items-baseline">
            <b-img blank blank-color="#dc3545" class="mr-2" width="12" height="12" :alt="$t('altTag',{ affiliate: $root.affiliate })"></b-img>
            <strong class="mr-auto">{{$t('favourite.title')}}</strong>
          </div>
        </template>
        {{$t('favourite.errLogin')}}
      </b-toast>
  </div>
</template>
<script>
import StarIcon from "vue-material-design-icons/Star.vue";
import IconFavoriteBorder from "vue-material-design-icons/HeartOutline.vue";
import FavoriteIcon from "vue-material-design-icons/Heart.vue";
import IconSetting from '../../components/icons/IconSetting/index';
import { mapActions, mapGetters } from "vuex";
export default {
  name: "ItemViewMobile",
  components: {
    StarIcon,
    IconFavoriteBorder,
    FavoriteIcon,
    IconSetting
  },
  props: {
    color: {
      type: String,
      default: ""
    },
    urlImage: {
      type: String,
      default: "/images/card1.png",
    },
    description: {
      type: String,
      default: ""
    },
    price: {
      type: Number,
      default: 0
    },
    province: {
      type: String,
      default: ""
    },
    district: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    listing_attributes_details: {
      type: Array,
      default: () => []
    },
    id: {
      type: Number,
      default: 0
    },
    isQuickSale: {
      type: Boolean,
      default: false
    },
    isNegotiable: {
      type: Boolean,
      default: false
    },
    isFeature: {
      type: Boolean,
      default: false
    },
    isHighlight: {
      type: Boolean,
      default: false
    },
    minSalary: {
      type: Number,
      default: 0
    },
    salaryType: {
      type: String,
      default: null
    },
    status: {
      type: Number,
      default: 0
    },
    is_approved: {
      type: Boolean,
      default: false
    },
    show_renew: {
      type: Number,
      default: 0
    },
    unapproval_message: {
      type: String,
      default: null
    },
    parentCategoryId: {
      type: Number,
      default: 0
    },
    name: {
      type: String,
      default: null
    },
  },
  data() {
    return {
      isFavorite: false,
      itemFavourite: null,
    };
  },
  watch: {
    listing_attributes_details:function(val){
      this.getListingAttr();
    }
  },
  created(){
    if(this.id) {
      // this.checkFavourites()
    }
  },
  methods: {
    ...mapActions("FavouriteController", ["CREATE_FAVOURITES_USER", "DELETE_FAVOURITES_USER"]),
    createFavourites() {
      if(this.$root.isAuthenticated && this.id)  {
        this.CREATE_FAVOURITES_USER({
          listing_id: this.id
        })
      }
    },
    deleteFavourites() {
      if(this.$root.isAuthenticated && this.itemFavourite && this.itemFavourite.id) {
        this.DELETE_FAVOURITES_USER({
          id: this.itemFavourite.id
        })
      }
    },
    favorite() {
      if(!this.$root.isAuthenticated) return this.$refs["favourite-toast"].show()
      this.isFavorite = !this.isFavorite;
      if(this.isFavorite) {
        this.createFavourites()
      }
      else {
        this.deleteFavourites()
      }
    },
    funcSubString(string, number){
      let subStr = '';
      if(string.length > number && string.indexOf(' ') !== -1){
          subStr = string.substring(0, string.substring(0, number).lastIndexOf(' ')) + ' ...';
      }else{
          subStr = string;
      }
      return subStr.toString();
    },
    funcSetting() {
      let obj={
        id : this.id,
        status : this.status,
        is_approved : this.is_approved,
        show_renew : this.show_renew,
        unapproval_message : this.unapproval_message,
        parentCategoryId : this.parentCategoryId,
        name : this.name
      }
      this.$emit('funcSetting', obj)
    }
  }
};
</script>
<style lang="scss">
@import "style";
</style>